<template>
	<div>
		<div class="box">
			<span class="float-right text-muted mr-3 mt-2">
				<a @click="loadData" class="no-select" v-tippy title="Refresh">
					<i class="fa fa-sync text-sm" :class="{ 'fa-spin': busy }"></i>
				</a>
			</span>
			<div class="p-3">
				<h6 v-if="messages.length > 0">Unread Messages</h6>
				<div v-if="messages.length > 0" class="streamline streamline-dotted mt-3">
					<div v-for="(message, i) in messages" :key="i" class="sl-item">
						<div class="sl-content">
							<span class="sl-date text-muted" style="margin-top: -4px;">{{
								fs.sinceString(message.created_at)
							}}</span>
							<div>
								<a v-if="true" class="no-select btn-subtle float-right">
									<span v-tippy title="View" @click="viewMessage(message)">
										<i class="fa fa-comment fa-lg"></i>
									</span>
								</a>
								<!-- <span>One</span> -->
								<span v-if="true" class="text-muted text-xs" v-html="message.text"></span>
							</div>
						</div>
					</div>
				</div>

				<hr v-if="both" class="mt-0" />

				<h6 v-if="responses.length > 0">Recently Scored</h6>
				<div v-if="responses.length > 0" class="streamline streamline-dotted mt-3">
					<div v-for="(response, i) in responses" :key="i" class="sl-item">
						<div class="sl-content">
							<span class="sl-date text-muted">{{ fs.sinceString(response.score.created_at) }}</span>
							<span class="sl-date text-muted float-right"
								>{{ response.messages }} {{ response.messages == 1 ? "comment" : "comments" }}</span
							>
							<div>
								<a v-if="true" class="no-select btn-subtle float-right">
									<span v-tippy title="View" @click="viewResponse(response)">
										<i class="fa fa-file fa-lg"></i>
									</span>
								</a>
								<div class="_600 pb-1">{{ response.assessment_name }}</div>
								<inline-score
									:score="response.score"
									:rubric="response.rubric"
									:maxTraits="12"
									tooltip
								/>
							</div>
						</div>
					</div>
				</div>

				<div v-if="loading">
					<h1 class="text-very-muted text-center py-2">
						<loading type="icon" />
					</h1>
				</div>
				<div v-if="!loading && !any">
					<h3 class="text-very-muted text-center py-2">No recent activity</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
a.btn-subtle {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a.btn-subtle:hover {
	opacity: 1;
}
.streamline .sl-item:before,
.streamline .sl-icon:before {
	top: 8px;
}
</style>

<script>
import ActivityService from "@/services/ActivityService";
import ViewingDriver from "@/services/ScoringDrivers/ViewingDriver";
import notie from "@/services/NotieService";
import fs from "@/services/FormatService";

import InlineScore from "@/components/InlineScore";

export default {
	name: "ScoringRecentActivity",

	props: {
		size: {
			type: Number,
			default: 10
		},
		user: true
	},

	components: { InlineScore },

	data() {
		return {
			fs: fs,
			busy: false,
			loading: true,
			responses: [],
			messages: []
		};
	},
	created() {
		this.loadData();
	},
	watch: {},
	computed: {
		any() {
			return this.messages.length > 0 || this.responses.length > 0;
		},
		both() {
			return this.messages.length > 0 && this.responses.length > 0;
		}
	},
	methods: {
		loadData() {
			this.busy = true;
			ActivityService.getRecentActivity(this.size)
				.then(resp => {
					this.responses = resp.data.responses;
					this.messages = resp.data.messages;
				})
				.catch(err => {
					notie.error("Failed to load user activity", err);
					console.error(err);
				})
				.finally(() => {
					this.loading = false;
					this.busy = false;
				});
		},

		viewMessage(message) {
			let aid = message.assessment_id;
			let iid = message.item_id;
			let rid = message.response_id;
			ViewingDriver.enter(this, aid, iid, rid);
		},

		viewResponse(response) {
			let aid = response.response.assessment_id;
			let iid = response.response.item_id;
			let rid = response.response.id;
			ViewingDriver.enter(this, aid, iid, rid);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Scoring/ScoringRecentActivity.vue